/*!
 * @author electricessence / https://github.com/electricessence/
 * Licensing: MIT https://github.com/electricessence/TypeScript.NET/blob/master/LICENSE.md
 */
define(["require", "exports", "./IndexEnumerator", "../../Types", "../../../extends"], function (require, exports, IndexEnumerator_1, Types_1, extends_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    // noinspection JSUnusedLocalSymbols
    var __extends = extends_1.default;
    var ArrayEnumerator = /** @class */ (function (_super) {
        __extends(ArrayEnumerator, _super);
        function ArrayEnumerator(arrayOrFactory, start, step) {
            if (start === void 0) { start = 0; }
            if (step === void 0) { step = 1; }
            return _super.call(this, function () {
                var array = Types_1.Type.isFunction(arrayOrFactory) ? arrayOrFactory() : arrayOrFactory;
                return {
                    source: array,
                    pointer: start,
                    length: array ? array.length : 0,
                    step: step
                };
            }) || this;
        }
        return ArrayEnumerator;
    }(IndexEnumerator_1.IndexEnumerator));
    exports.ArrayEnumerator = ArrayEnumerator;
    exports.default = ArrayEnumerator;
});
